import { Request } from './';
import { RequestsState } from './reducer';

type ReduxState = {
  requests: RequestsState;
};

export const getRequestById = <T extends ReduxState>(
  state: T,
  requestId: string,
): RequestsState['requests'][string] | undefined => {
  return state.requests.requests[requestId];
};

export const getRequests = <T extends ReduxState>(
  state: T,
  predicate: (requestId: string, request: RequestsState['requests'][string]) => boolean,
) => {
  const requests: Array<[string, RequestsState['requests'][string]]> = [];
  Object.keys(state.requests).forEach((requestId) => {
    const request = state.requests.requests[requestId];
    if (predicate(requestId, request)) {
      requests.push([requestId, request]);
    }
  });
  return requests;
};

export const isRequestInState = <T extends ReduxState>(
  state: T,
  requestId: string,
  requestState: Request<unknown>['state'],
) => {
  const request = state.requests.requests[requestId];
  return !!request && request.state === requestState;
};

export const isRequestLoading = <T extends ReduxState>(state: T, requestId: string) =>
  isRequestInState(state, requestId, 'loading');
export const isRequestSuccessful = <T extends ReduxState>(state: T, requestId: string) =>
  isRequestInState(state, requestId, 'success');
export const isRequestErrored = <T extends ReduxState>(state: T, requestId: string) =>
  isRequestInState(state, requestId, 'error');
